import { useEffect } from "react";

export function useLazyImages(deps = []) {
  useEffect(() => {
    const images = Array.from(document.querySelectorAll("[data-g-lazy]"));
    if (!images.length) return;

    const reveal = (img) => {
      const src = img.getAttribute("data-src");
      if (src) img.src = src;
      img.removeAttribute("data-g-lazy");
    };

    if (!("IntersectionObserver" in window)) {
      images.forEach(reveal);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    });

    images.forEach((img) => observer.observe(img));

    return () => observer.disconnect();
  }, deps);
}
